// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"9387784c","478":"a286b6dd","506":"ebf5bd2d","582":"9387784c","682":"9387784c","822":"a286b6dd"}[chunkId] + ".chunk.css";
};